import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ForgetPassword from '../../components/pages/ForgetPassword';
import AiOcr from '../../components/pages/AiOcr';
import ReadingResultDeleted from '../../components/pages/aiOcrDelete';
import AuthLogin from '../../components/pages/AuthLogin';
import Staff from '../../components/pages/Staff';
import PasswordChange from '../../components/pages/PasswordChange';
import StaffDeleteComplete from '../../components/pages/DeleteCompleted';
import PasswordChangeComplete from '../../components/pages/PasswordChangeComplete';
import PasswordResetComplete from '../../components/pages/PasswordResetComplete';
import StaffEditComplete from '../../components/pages/StaffEditComplete';
import StaffInviteCancel from '../../components/pages/StaffInviteCancel';
import StaffInviteComplete from '../../components/pages/StaffInviteComplete';
import StaffInvite from '../../components/pages/StaffInvite';
import StaffRegisterComplete from '../../components/pages/StaffRegisterComplete';
import StaffRegister from '../../components/pages/StaffRegister';
import AiOcrResult from '../../components/pages/AiOcrResult';
import GroupManage from '../../components/pages/GroupManage';
import GroupCreate from '../../components/pages/GroupCreate';
import GroupEdit from '../../components/pages/GroupEdit';
import NotFound from '../../components/uiParts/NotFound';
import { AuthProvider } from '../../contexts/auth';
import { GroupProvider } from '../../contexts/group';
import Action from '../../components/pages/common/Action';
import { AccessProvider } from '../../contexts/index';
import ProtectedStaffEdit from './ProtectedStaffEdit';
import ScrollToTop from '../../components/utils/ScrollToTop';

function RoutesIndex(): JSX.Element {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AuthProvider>
        <GroupProvider>
          <AccessProvider>
            <Routes>
              <Route path="/" element={<AuthLogin />} />
              <Route path={`/action`} element={<Action />} />
              <Route path="/staff/edit" element={<ProtectedStaffEdit />} />
              <Route path="/ai-ocr" element={<AiOcr />} />
              <Route path="/ai-ocr/delete/complete" element={<ReadingResultDeleted />} />
              <Route path="/ai-ocr/result/:resultId" element={<AiOcrResult />} />
              {/* グループ別AI OCR画面 */}
              <Route path="/groups/:groupId/ai-ocr" element={<AiOcr />} />
              <Route
                path="/groups/:groupId/ai-ocr/delete/complete"
                element={<ReadingResultDeleted />}
              />
              <Route path="/groups/:groupId/ai-ocr/result/:resultId" element={<AiOcrResult />} />
              {/* グループ管理画面（管理者用） */}
              <Route path="/groups/manage" element={<GroupManage />} />
              <Route path="/groups/create" element={<GroupCreate />} />
              <Route path="/groups/:groupId/edit" element={<GroupEdit />} />
              <Route path="/auth/password_change/" element={<PasswordChange />} />
              <Route path="/auth/password_change/complete" element={<PasswordChangeComplete />} />
              <Route path="/auth/password_reset" element={<ForgetPassword />} />
              <Route path="/auth/password_reset/complete" element={<PasswordResetComplete />} />
              <Route path="/staff/invite/cancel" element={<StaffInviteCancel />} />
              <Route path="/staff/invite" element={<StaffInvite />} />
              <Route path="/staff/register/complete" element={<StaffRegisterComplete />} />
              <Route path="/staff/invite" element={<StaffInvite />} />
              <Route path="/staff/invite/complete" element={<StaffInviteComplete />} />
              <Route path="/staff/delete/complete" element={<StaffDeleteComplete />} />
              <Route path="/staff/edit/complete" element={<StaffEditComplete />} />
              <Route path="/staff/register/complete" element={<StaffRegisterComplete />} />
              <Route path="/staff/register" element={<StaffRegister />} />
              <Route path="/staff" element={<Staff />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </AccessProvider>
        </GroupProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default RoutesIndex;
